import type {Logger} from 'src/logger';

/**
 * A no-operation (noop) logger implementation that performs no logging.
 */
export const noopLogger: Logger = {
  log() {
    // noop
  },
  debug() {
    // noop
  },
  warn() {
    // noop
  },
  error() {
    // noop
  },
};
